'use strict';
/* global angular */
( function () {
	function reportDatepickerController () {
		var self = this;

		function clickHandler ( $event ) {
			$event.preventDefault();
			$event.stopPropagation();

			self.toggleHandler( { 'data' : self.isOpen } );
		}

		function activate () {
			self.formats     = [ 'MM/dd/yy' ];
			self.format      = self.formats[ 0 ];
			self.dateOptions = {
				'formatYear'   : 'yyyy',
				'startingDate' : 0,
				'showWeeks'    : false
			};
		}

		activate();

		self.clickHandler = clickHandler;
	}

	angular
		.module( 'app.report' )
		.controller( 'reportDatepickerController', reportDatepickerController );
} )();
